import { render } from "./PatientList.vue?vue&type=template&id=400912e8&ts=true"
import script from "./PatientList.ts?vue&type=script&lang=ts&external"
export * from "./PatientList.ts?vue&type=script&lang=ts&external"

import "./PatientList.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__